import styled from 'styled-components';

export const RangeContainer = styled.div`
  padding: 25px 15px 35px;

  .ant-slider-mark {
    top: 20px;
    font-size: 0.8rem;
    color: ${({ theme }) => theme.baseBlue.a10};
  }
`;
